import { collection, Timestamp, } from "firebase/firestore";
import { warnUnknownFields } from "./converterWarnings";
export const DEAD_LETTER_FIELDS = [
    "schemaVersion",
    "kind",
    "status",
    "source",
    "failure",
    "subject",
    "payload",
    "createdAt",
    "updatedAt",
    "expireAt",
    "resolvedAt",
    "resolution",
];
function toDate(value) {
    if (value instanceof Date)
        return value;
    if (value instanceof Timestamp)
        return value.toDate();
    return null;
}
function toTimestamp(value) {
    return value instanceof Date ? Timestamp.fromDate(value) : value;
}
export const deadLetterConverter = {
    toFirestore(value) {
        const deadLetter = value;
        return {
            schemaVersion: deadLetter.schemaVersion,
            kind: deadLetter.kind,
            status: deadLetter.status,
            source: {
                ...deadLetter.source,
                eventTime: toTimestamp(deadLetter.source.eventTime),
            },
            failure: {
                ...deadLetter.failure,
                occurredAt: toTimestamp(deadLetter.failure.occurredAt),
            },
            subject: deadLetter.subject,
            payload: deadLetter.payload,
            createdAt: toTimestamp(deadLetter.createdAt),
            updatedAt: toTimestamp(deadLetter.updatedAt),
            expireAt: toTimestamp(deadLetter.expireAt),
            resolvedAt: toTimestamp(deadLetter.resolvedAt),
            resolution: deadLetter.resolution ?? null,
        };
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        warnUnknownFields("packages/ui DeadLetterEnvelope.fromFirestore", data, DEAD_LETTER_FIELDS);
        return {
            id: snapshot.id,
            path: snapshot.ref.path,
            schemaVersion: 1,
            kind: data.kind,
            status: data.status,
            source: {
                ...data.source,
                eventTime: toDate(data.source?.eventTime),
            },
            failure: {
                ...data.failure,
                occurredAt: toDate(data.failure?.occurredAt) ?? new Date(0),
            },
            subject: data.subject,
            payload: data.payload ?? {},
            createdAt: toDate(data.createdAt) ?? new Date(0),
            updatedAt: toDate(data.updatedAt) ?? new Date(0),
            expireAt: toDate(data.expireAt) ?? new Date(0),
            resolvedAt: toDate(data.resolvedAt),
            resolution: data.resolution ?? null,
        };
    },
};
export function deadLettersCollection(db) {
    return collection(db, "deadLetters").withConverter(deadLetterConverter);
}
